import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'name',
    limit: 0,
    ...params,
  });

  return Service.get(`languages?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('languages', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`languages/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`languages/${id}`, config);
